import './ScrollDown.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { setActive } from 'src/app/redux/slice/sceneSlice';

const ScrollDown = () => {
  const isActive = useSelector((state) => state.sceneController.active);
  const dispatch = useDispatch();

  const flag = useRef(false);

  const listenScrollEvent = () => {
    if (window.scrollY < 1550) {
      flag.current && dispatch(setActive(false));
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', listenScrollEvent);
    return () => {
      window.removeEventListener('scroll', listenScrollEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    flag.current = isActive;
  }, [isActive]);

  return (
    <div className={isActive ? 'scrolldown' : 'scrolldown-hidden'}>
      <div className="scrolldown-icon"></div>
      Scroll
    </div>
  );
};

export default ScrollDown;
